import type { CoreTokens } from '@cellula/react';
import { coreTokens } from '@cellula/react';
import { tokensData } from './tokens_data';

export interface DefaultTokens extends CoreTokens {
	color: {
		border: {
			default: string;
			brand: string;
			interactive: string;
			input: string;
			highlight: string;
			muted: string;
		};
		content: {
			default: string;
			brand: string;
			mutedBrand: string;
			interactive: string;
			muted: string;
			placeholder: string;
			onInteractive: string;
			onDark: string;
			onAppNav: string;
			highlight: string;
			onHighlight: string;
		};
		bg: {
			highlight: string;
			pageBrand: string;
			interactive: string;
			interactiveHover: string;
			interactiveActive: string;
			interactiveMutedHover: string;
			interactiveMutedActive: string;
			page: string;
			surface: string;
			surfaceMuted: string;
			surfaceDark: string;
			surfaceBrand: string;
			surfaceDarkBrand: string;
			deselected: string;
			deselectedHover: string;
			deselectedActive: string;
			readOnly: string;
		};
		warning: {
			bg: string;
			bgLight: string;
			bgHover: string;
			border: string;
			borderMuted: string;
			content: string;
			contentMuted: string;
			contentPlaceholder: string;
		};
		danger: {
			bg: string;
			bgHover: string;
			bgActive: string;
			border: string;
			borderMuted: string;
			content: string;
			contentMuted: string;
		};
		success: {
			bg: string;
			bgHover: string;
			bgActive: string;
			border: string;
			borderMuted: string;
			content: string;
			contentMuted: string;
		};
		info: {
			bg: string;
			bgHover: string;
			border: string;
			borderMuted: string;
			content: string;
			contentMuted: string;
		};
		focus: string;
	};
	component: {
		iconButton: {
			hover: string;
			active: string;
			hoverInteractive: string;
			activeInteractive: string;
			hoverOnDark: string;
			activeOnDark: string;
			hoverInfo: string;
			activeInfo: string;
			hoverSuccess: string;
			activeSuccess: string;
			hoverWarning: string;
			activeWarning: string;
			hoverDanger: string;
			activeDanger: string;
		};
	};
}

export const tokens: DefaultTokens = {
	...coreTokens,
	color: {
		border: {
			default: `var(${tokensData.colorNeutral400.cssVar})`,
			brand: `var(${tokensData.colorPrimary400.cssVar})`,
			interactive: `var(${tokensData.colorPrimary800.cssVar})`,
			input: `var(${tokensData.colorNeutral500.cssVar})`,
			highlight: `var(${tokensData.colorAccent300.cssVar})`,
			muted: `var(${tokensData.colorNeutral200.cssVar})`,
		},
		content: {
			default: `var(${tokensData.colorNeutral1000.cssVar})`,
			brand: `var(${tokensData.colorPrimary1000.cssVar})`,
			mutedBrand: `var(${tokensData.colorPrimary800.cssVar})`,
			interactive: `var(${tokensData.colorPrimary800.cssVar})`,
			muted: `var(${tokensData.colorNeutral800.cssVar})`,
			placeholder: `var(${tokensData.colorNeutral500.cssVar})`,
			onInteractive: `var(${tokensData.colorNeutral0.cssVar})`,
			onDark: `var(${tokensData.colorNeutral0.cssVar})`,
			onAppNav: `var(${tokensData.colorNeutral0.cssVar})`,
			highlight: `var(${tokensData.colorAccent800.cssVar})`,
			onHighlight: `var(${tokensData.colorAccent900.cssVar})`,
		},
		bg: {
			pageBrand: `var(${tokensData.colorPrimary100.cssVar})`,
			surfaceMuted: `var(${tokensData.colorNeutral100.cssVar})`,
			surfaceBrand: `var(${tokensData.colorPrimary200.cssVar})`,
			surfaceDarkBrand: `var(${tokensData.colorPrimary700.cssVar})`,
			highlight: `var(${tokensData.colorAccent300.cssVar})`,
			interactive: `var(${tokensData.colorPrimary800.cssVar})`,
			interactiveHover: `var(${tokensData.colorPrimary900.cssVar})`,
			interactiveActive: `var(${tokensData.colorPrimary1000.cssVar})`,
			interactiveMutedHover: `var(${tokensData.colorPrimary800t08.cssVar})`,
			interactiveMutedActive: `var(${tokensData.colorPrimary800t12.cssVar})`,
			page: `var(${tokensData.colorNeutral100.cssVar})`,
			surface: `var(${tokensData.colorNeutral0.cssVar})`,
			surfaceDark: `var(${tokensData.colorNeutral800.cssVar})`,
			deselected: `var(${tokensData.colorNeutral400.cssVar})`,
			deselectedHover: `var(${tokensData.colorNeutral500.cssVar})`,
			deselectedActive: `var(${tokensData.colorNeutral600.cssVar})`,
			readOnly: `var(${tokensData.colorNeutral200.cssVar})`,
		},
		warning: {
			bg: `var(${tokensData.colorWarning300.cssVar})`,
			bgLight: `var(${tokensData.colorWarning100.cssVar})`,
			bgHover: `var(${tokensData.colorWarning400.cssVar})`,
			border: `var(${tokensData.colorWarning600.cssVar})`,
			borderMuted: `var(${tokensData.colorWarning500.cssVar})`,
			content: `var(${tokensData.colorWarning1000.cssVar})`,
			contentMuted: `var(${tokensData.colorWarning800.cssVar})`,
			contentPlaceholder: `var(${tokensData.colorWarning700.cssVar})`,
		},
		danger: {
			bg: `var(${tokensData.colorDanger300.cssVar})`,
			bgHover: `var(${tokensData.colorDanger400.cssVar})`,
			bgActive: `var(${tokensData.colorDanger500.cssVar})`,
			border: `var(${tokensData.colorDanger600.cssVar})`,
			borderMuted: `var(${tokensData.colorDanger500.cssVar})`,
			content: `var(${tokensData.colorDanger1000.cssVar})`,
			contentMuted: `var(${tokensData.colorDanger800.cssVar})`,
		},
		success: {
			bg: `var(${tokensData.colorSuccess300.cssVar})`,
			bgHover: `var(${tokensData.colorSuccess400.cssVar})`,
			bgActive: `var(${tokensData.colorSuccess500.cssVar})`,
			border: `var(${tokensData.colorSuccess600.cssVar})`,
			borderMuted: `var(${tokensData.colorSuccess500.cssVar})`,
			content: `var(${tokensData.colorSuccess1000.cssVar})`,
			contentMuted: `var(${tokensData.colorSuccess800.cssVar})`,
		},
		info: {
			bg: `var(${tokensData.colorInfo300.cssVar})`,
			bgHover: `var(${tokensData.colorInfo400.cssVar})`,
			border: `var(${tokensData.colorInfo600.cssVar})`,
			borderMuted: `var(${tokensData.colorInfo500.cssVar})`,
			content: `var(${tokensData.colorInfo1000.cssVar})`,
			contentMuted: `var(${tokensData.colorInfo800.cssVar})`,
		},
		focus: `var(${tokensData.colorFocus.cssVar})`,
	},
	component: {
		iconButton: {
			hover: `var(${tokensData.componentIconButtonHover.cssVar})`,
			active: `var(${tokensData.componentIconButtonActive.cssVar})`,
			hoverInteractive: `var(${tokensData.componentIconButtonHoverInteractive.cssVar})`,
			activeInteractive: `var(${tokensData.componentIconButtonActiveInteractive.cssVar})`,
			hoverOnDark: `var(${tokensData.componentIconButtonHoverOnDark.cssVar})`,
			activeOnDark: `var(${tokensData.componentIconButtonActiveOnDark.cssVar})`,
			hoverInfo: `var(${tokensData.componentIconButtonHoverInfo.cssVar})`,
			activeInfo: `var(${tokensData.componentIconButtonActiveInfo.cssVar})`,
			hoverSuccess: `var(${tokensData.componentIconButtonHoverSuccess.cssVar})`,
			activeSuccess: `var(${tokensData.componentIconButtonActiveSuccess.cssVar})`,
			hoverWarning: `var(${tokensData.componentIconButtonHoverWarning.cssVar})`,
			activeWarning: `var(${tokensData.componentIconButtonActiveWarning.cssVar})`,
			hoverDanger: `var(${tokensData.componentIconButtonHoverDanger.cssVar})`,
			activeDanger: `var(${tokensData.componentIconButtonActiveDanger.cssVar})`,
		},
	},
};

interface PrimitiveColorTokens {
	primary: {
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
	accent: {
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
	neutral: {
		'0': string;
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
	warning: {
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
	danger: {
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
	success: {
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
	info: {
		'100': string;
		'200': string;
		'300': string;
		'400': string;
		'500': string;
		'600': string;
		'700': string;
		'800': string;
		'900': string;
		'1000': string;
	};
}

export const primitiveColorTokens: PrimitiveColorTokens = {
	primary: {
		'100': `var(${tokensData.colorPrimary100.cssVar})`,
		'200': `var(${tokensData.colorPrimary200.cssVar})`,
		'300': `var(${tokensData.colorPrimary300.cssVar})`,
		'400': `var(${tokensData.colorPrimary400.cssVar})`,
		'500': `var(${tokensData.colorPrimary500.cssVar})`,
		'600': `var(${tokensData.colorPrimary600.cssVar})`,
		'700': `var(${tokensData.colorPrimary700.cssVar})`,
		'800': `var(${tokensData.colorPrimary800.cssVar})`,
		'900': `var(${tokensData.colorPrimary900.cssVar})`,
		'1000': `var(${tokensData.colorPrimary1000.cssVar})`,
	},
	accent: {
		'100': `var(${tokensData.colorAccent100.cssVar})`,
		'200': `var(${tokensData.colorAccent200.cssVar})`,
		'300': `var(${tokensData.colorAccent300.cssVar})`,
		'400': `var(${tokensData.colorAccent400.cssVar})`,
		'500': `var(${tokensData.colorAccent500.cssVar})`,
		'600': `var(${tokensData.colorAccent600.cssVar})`,
		'700': `var(${tokensData.colorAccent700.cssVar})`,
		'800': `var(${tokensData.colorAccent800.cssVar})`,
		'900': `var(${tokensData.colorAccent900.cssVar})`,
		'1000': `var(${tokensData.colorAccent1000.cssVar})`,
	},
	neutral: {
		'0': `var(${tokensData.colorNeutral0.cssVar})`,
		'100': `var(${tokensData.colorNeutral100.cssVar})`,
		'200': `var(${tokensData.colorNeutral200.cssVar})`,
		'300': `var(${tokensData.colorNeutral300.cssVar})`,
		'400': `var(${tokensData.colorNeutral400.cssVar})`,
		'500': `var(${tokensData.colorNeutral500.cssVar})`,
		'600': `var(${tokensData.colorNeutral600.cssVar})`,
		'700': `var(${tokensData.colorNeutral700.cssVar})`,
		'800': `var(${tokensData.colorNeutral800.cssVar})`,
		'900': `var(${tokensData.colorNeutral900.cssVar})`,
		'1000': `var(${tokensData.colorNeutral1000.cssVar})`,
	},
	warning: {
		'100': `var(${tokensData.colorWarning100.cssVar})`,
		'200': `var(${tokensData.colorWarning200.cssVar})`,
		'300': `var(${tokensData.colorWarning300.cssVar})`,
		'400': `var(${tokensData.colorWarning400.cssVar})`,
		'500': `var(${tokensData.colorWarning500.cssVar})`,
		'600': `var(${tokensData.colorWarning600.cssVar})`,
		'700': `var(${tokensData.colorWarning700.cssVar})`,
		'800': `var(${tokensData.colorWarning800.cssVar})`,
		'900': `var(${tokensData.colorWarning900.cssVar})`,
		'1000': `var(${tokensData.colorWarning1000.cssVar})`,
	},
	danger: {
		'200': `var(${tokensData.colorDanger200.cssVar})`,
		'100': `var(${tokensData.colorDanger100.cssVar})`,
		'300': `var(${tokensData.colorDanger300.cssVar})`,
		'400': `var(${tokensData.colorDanger400.cssVar})`,
		'500': `var(${tokensData.colorDanger500.cssVar})`,
		'600': `var(${tokensData.colorDanger600.cssVar})`,
		'700': `var(${tokensData.colorDanger700.cssVar})`,
		'800': `var(${tokensData.colorDanger800.cssVar})`,
		'900': `var(${tokensData.colorDanger900.cssVar})`,
		'1000': `var(${tokensData.colorDanger1000.cssVar})`,
	},
	success: {
		'100': `var(${tokensData.colorSuccess100.cssVar})`,
		'200': `var(${tokensData.colorSuccess200.cssVar})`,
		'300': `var(${tokensData.colorSuccess300.cssVar})`,
		'400': `var(${tokensData.colorSuccess400.cssVar})`,
		'500': `var(${tokensData.colorSuccess500.cssVar})`,
		'600': `var(${tokensData.colorSuccess600.cssVar})`,
		'700': `var(${tokensData.colorSuccess700.cssVar})`,
		'800': `var(${tokensData.colorSuccess800.cssVar})`,
		'900': `var(${tokensData.colorSuccess900.cssVar})`,
		'1000': `var(${tokensData.colorSuccess1000.cssVar})`,
	},
	info: {
		'100': `var(${tokensData.colorInfo100.cssVar})`,
		'200': `var(${tokensData.colorInfo200.cssVar})`,
		'300': `var(${tokensData.colorInfo300.cssVar})`,
		'400': `var(${tokensData.colorInfo400.cssVar})`,
		'500': `var(${tokensData.colorInfo500.cssVar})`,
		'600': `var(${tokensData.colorInfo600.cssVar})`,
		'700': `var(${tokensData.colorInfo700.cssVar})`,
		'800': `var(${tokensData.colorInfo800.cssVar})`,
		'900': `var(${tokensData.colorInfo900.cssVar})`,
		'1000': `var(${tokensData.colorInfo1000.cssVar})`,
	},
};
